//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'RequestWorkTypesPickerPackagesWarning',
  props: {
    worksFromRequest: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      columns: [
        {
          name: 'name',
          label: 'Работа',
          field: 'name',
          align: 'left',
          sortable: false
        },
        {
          name: 'packages',
          label: 'Список комплексов',
          field: 'workPackages',
          align: 'left',
          sortable: false
        }
      ]
    }
  },
  computed: {
    items: function () {
      return Object.values(this.worksFromRequest)
    }
  }
}
